import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { DEFAULT_SHOWCASE_ROOM, SortOrder } from '@store/constants'
import { RootStateTypeExtra } from '@store/types'

import {
  selectShowcaseRoomConfigFromResult,
  selectShowcaseRoomsFromResult,
  useGetShowcaseRoomConfigQuery,
  useGetShowcaseRoomsQuery,
} from '@api/showcase-room'

const useRoomConfigData = () => {
  const projectName = useSelector(
    (state: RootStateTypeExtra) => state.projectIdentity.projectName
  )
  const roomName = useSelector((state: RootStateTypeExtra) =>
    (state.appConfig.room || DEFAULT_SHOWCASE_ROOM).toLowerCase()
  )

  const { isLoaded: isLoadedRoomsQuery, showcaseRooms: allRooms } =
    useGetShowcaseRoomsQuery(
      { projectName, pagination: false, sort_order: SortOrder.ASC },
      { selectFromResult: selectShowcaseRoomsFromResult }
    )

  const roomId = useMemo<string | undefined>(() => {
    const matchedRoom = allRooms?.find(
      (room) => room.name?.toLowerCase() === roomName
    )
    return matchedRoom?.id
  }, [roomName, allRooms])

  const {
    isLoaded: isLoadedRoomConfigQuery,
    showcaseRoomConfig: roomConfigData,
  } = useGetShowcaseRoomConfigQuery(
    {
      projectName,
      showcaseRoomId: roomId || '',
    },
    {
      selectFromResult: selectShowcaseRoomConfigFromResult,
      skip: !roomId,
    }
  )

  return {
    roomConfigData: roomId ? roomConfigData : undefined,
    isProcessing: !(isLoadedRoomsQuery && isLoadedRoomConfigQuery),
  }
}

export default useRoomConfigData
